import React, { useState, useEffect, useRef, useLayoutEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { getSeason, addSeason, deleteSeason, updateSeason } from "../../redux/actions/season.action";
import { getDefaultCompany, getOneDefaultCompany } from "../../redux/actions/defaultCompany";
import { getCompanyAccess, updateCompanyAccess, deleteCompanyAccess, getAllCompany, createCompanyAccess } from "../../redux/actions/companyAccess"
import { getLog } from "../../redux/actions/log.action"
import { getRights } from "../../redux/actions/userRights.action";

import { ReadCookie } from "../../utils/readCookie";
import PageHeader from "../../components/PageHeader/PageHeader"
import CrudButtons from "../../components/CrudButtons/CrudButtons";
import Tables from "../../components/Table/Tables"
import { Button, Row, Col, Form, Input, Checkbox, Tabs, Tooltip, Popconfirm, Modal, Divider } from 'antd';
import { CloseCircleOutlined, DeleteOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { logColumns, seasonColumns } from "../../utils/cols";
import notification from '../../utils/notification';
import "../Style/style.css";
import { TabTitle } from '../../utils/GeneralFunction';
const { TabPane } = Tabs;
export default function Season({ token }) {
    TabTitle("Season")
    const menuId = ReadCookie('menuId')
    const dCompanyId = ReadCookie('defaultCompany')
    const seasonNameInput = useRef(null);
    const [visible, setVisible] = useState(false);
    const [form] = Form.useForm();
    const [seasonObj, setSeasonObj] = useState(null);
    const dispatch = useDispatch();
    const { season, getDemoDefaultCompany, companyAccess, companyAll, log, userRights } = useSelector(state => state)
    // const stateData = useSelector(state => state)
    const [minimize, setMinimize] = useState(false);
    const [check, setCheck] = useState(false);
    const [seasonName, setSeasonName] = useState('');
    const [disable, setDisable] = useState(false);
    const [formState, setFormState] = useState('view');

    const handleEdit = (record, type) => {
        if (type === "active") {
            dispatch(updateCompanyAccess(token, record)).then((res) => dispatch(getCompanyAccess(token, seasonObj.season_id, menuId)));
        }
        if (type === "delete") {
            dispatch(deleteCompanyAccess(token, record)).then((res) => dispatch(getCompanyAccess(token, seasonObj.season_id, menuId)));
        }
    }

    const createAssignCompany = (record) => {
        dispatch(createCompanyAccess(token, record, seasonObj.season_id, menuId)).then((res) => dispatch(getCompanyAccess(token, seasonObj.season_id, menuId)))
    }

    const companyCol = [
        { title: 'Company ID', dataIndex: 'company_id', key: 'company_id', },
        { title: 'Company Name', dataIndex: 'company_name', key: 'company_name', },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <>
                    <Tooltip title="Minimize" color="#fbfbfb"  >
                    </Tooltip>
                    {
                        record.is_active ?
                            <Tooltip title="Activate" color="#fbfbfb"  ><CheckCircleOutlined className='color-green' onClick={() => handleEdit(record, "active")} /></Tooltip> : <Tooltip title="Deactivate" color="#fbfbfb"  ><CloseCircleOutlined className="color-red" onClick={() => handleEdit(record, "active")} /></Tooltip>}
                    {
                        dCompanyId === record.company_id.toString() ?
                            <Tooltip title="Default company can't be deleted" color="#fbfbfb"  >
                                <DeleteOutlined disabled twoToneColor="red" className='mlpx-5' />
                            </Tooltip> :
                            <Tooltip title="delete" color="#fbfbfb"  >
                                <Popconfirm placement="top" title={"Are you sure to delete this?"} onConfirm={() => handleEdit(record, "delete")} okText="Yes" cancelText="No">
                                    <DeleteOutlined twoToneColor="red" className='mlpx-5' />
                                </Popconfirm>
                            </Tooltip>
                    }
                </>
            ),
        },
    ];
    const companyAccessCol = [
        { title: 'ID', dataIndex: 'company_id', key: 'company_id', },
        { title: 'Company Name', dataIndex: 'company_name', key: 'company_name', },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <>
                    {
                        companyAccess?.payload?.data?.find(m => m.company_id === record?.company_id) ?
                            <>
                                <Tooltip title="Already assigned" color="#fbfbfb"  >
                                    <Button className='modalActionBTN' disabled shape='circle' icon={<CheckCircleOutlined className="color-red" />} />
                                </Tooltip>
                            </> :

                            <Tooltip title="Click to assign" color="#fbfbfb"  >
                                <Button className='modalActionBTN' onClick={() => createAssignCompany(record)} shape='circle' icon={<CloseCircleOutlined className='color-green' />} />
                            </Tooltip>
                    }
                </>
            ),
        },
    ];

    // useEffect(() => {
    //     dispatch(getDefaultCompany(token));
    // }, [token])

    useEffect(() => {
        dispatch(getSeason(token, menuId))
    }, [token])

    useLayoutEffect(() => {
        dispatch(getRights(token, menuId)).then((res) => {
            if (res.type === "GET_USER_RIGHTS_SUCCESS") {
                if (!res?.payload.can_add) {
                    setFormState("table")
                }
            }
        });
    }, [])

    useEffect(() => {

        if (seasonObj) {
            setFormState('view')
            form.setFieldsValue({
                id: seasonObj.season_id,
                season: seasonObj.season_name,
                active: seasonObj.is_active
            });
            setSeasonName(seasonObj.season_name)
            setCheck(seasonObj.is_active)
            dispatch(getCompanyAccess(token, seasonObj.season_id, menuId))

        }
    }, [seasonObj]);

    useEffect(() => {
        if (seasonName === '') {
            setDisable(true)
        } else {
            setDisable(false)
        }
    }, [seasonName])

    const showModal = () => {
        dispatch(getAllCompany(token));
        setVisible(true);
    };

    const handleOk = () => {
        setVisible(false);
    };

    const handleCancel = () => {
        setVisible(false);
    };
    const handleTab = (key) => {
        if (key === "logs") {
            // data: { inv_style: "inv_style", admin_company_entity_access: "admin_company_entity_access" }
            dispatch(getLog(token, { inv_style: "inv_style", admin_company_entity_access: "admin_company_entity_access" }))
        }
    }

    const formSave = () => {
        if (formState === "add") {
            dispatch(addSeason(token, { seasonName, check }, menuId)).then((res) => {

                if (res.type === "ADD_SEASON_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data)
                }
                if (res.type === "ADD_SEASON_SUCCESS") {
                    let data = {
                        company_id: dCompanyId
                    }
                    dispatch(createCompanyAccess(token, data, res?.payload?.season_id, menuId)).then((res) => dispatch(getCompanyAccess(token, seasonObj.season_id, menuId)))
                    notification("success", "Season Created", "Record created successfully!");
                    form.setFieldsValue({
                        season: ""
                    })
                    setFormState("")
                    // setCheck(false)
                    setSeasonName("")
                    setSeasonObj(null)
                }
                dispatch(getSeason(token, menuId))

            })

        }

        if (formState === "edit") {
            dispatch(updateSeason(token, { seasonName, check }, seasonObj.season_id)).then((res) => {
                if (res.type === "UPDATE_SEASON_ERROR") {
                    notification("error", "Update", "Something went wrong")
                }
                if (res.type === "UPDATE_SEASON_SUCCESS") {
                    notification("success", "Season Updated", "Record updated successfully")
                }
                dispatch(getSeason(token, menuId))
            })


        }


    }

    const handleDelete = () => {
        if (seasonObj) {
            dispatch(deleteSeason(token, seasonObj.season_id)).then((res) => {
                if (res.type === "DELETE_SEASON_SUCCESS") {
                    notification("success", "Season Deleted", "Record deleted successfully!");
                }
                if (res.type === "DELETE_SEASON_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data);
                }
                form.setFieldsValue({
                    season: ""
                })
                // setCheck(false)
                setSeasonName("")
                setSeasonObj(null)
                setFormState('')
                dispatch(getSeason(token, menuId))

            })
        }
    }
    useEffect(() => {
        if (formState === "add") {
            dispatch(getOneDefaultCompany(token, dCompanyId));
            seasonNameInput.current.focus();
            form.setFieldsValue({
                season: ""
            })
            setCheck(true)
            setSeasonName("")
            setSeasonObj(null)
        }
    }, [formState]);

    const filterReset = () => {
        setFormState("view")
    }
    return (
        <div className='styleContainer' >
            <div className='styleBody h-100'  >
                <PageHeader title={"Season"} minimize={setMinimize} check={minimize} />
                {
                    !minimize &&
                    <div className='bodyStyle' >
                        <div className='crudDiv' ><CrudButtons rights={userRights?.payload} reset={filterReset} formType={formState} save={formSave} disable={disable} formState={setFormState} onDelete={handleDelete} /></div>

                        <div className='styleContent' >
                            <Row className='tables-main-row-new' >
                                <Col xs={24} sm={24} md={8} lg={6} xl={6}>
                                    <div className='styleTable' >
                                        <Tables type="season" seasonObj={setSeasonObj} scroll={602} perPage={25} source={season?.payload?.data} col={seasonColumns} paginate load={season.loading} />
                                    </div>
                                </Col>
                                <Col xs={24} sm={24} md={16} lg={18} xl={18}>
                                    <div className='styleForm'  >
                                        <Form
                                            form={form}
                                            name="basic"
                                            labelCol={{ span: 8 }}
                                        >
                                            <div className='customRow styleFormUpper '>
                                            {seasonObj !== null && !(formState === "add") &&
                                                <Form.Item
                                                    label="ID"
                                                    name="id"
                                                    initialValue={form.getFieldValue().id}
                                                    labelCol={{ span: 10 }}
                                                    wrapperCol={{ span: 14 }}
                                                >
                                                    <Input className='styleInput id-field-style' readOnly />

                                                </Form.Item>
                                            }
                                            <div className='customCols slc'>
                                            <Form.Item
                                                label="Season"
                                                name="season"
                                                labelCol={{ span: 10 }}
                                                wrapperCol={{ span: 14 }}
                                                initialValue={form.getFieldValue().season}
                                            >

                                                <Input size='small' disabled={!(formState === "add" || formState === "edit")} ref={seasonNameInput} onChange={(e) => setSeasonName(e.target.value)} className='styleInput' />
                                            </Form.Item>
                                            </div>
                                            <div className='customCols slc'>
                                            <Form.Item
                                                label="Active"
                                                name="active"
                                                labelCol={{ span: 10 }}
                                                wrapperCol={{ span: 14 }}
                                            >
                                                <Checkbox disabled={!(formState === "add" || formState === "edit")} checked={check} onChange={(e) => setCheck(e.target.checked)} />
                                            </Form.Item>
                                            </div>
                                            </div>
 
                                        </Form>
                                        <div className='modalStyle' >

                                            {seasonObj === null ?
                                                <Tooltip title="Please select style first" color="#fbfbfb"  >
                                                    <Button disabled={seasonObj === null ? true : false} className='' onClick={showModal} >Assign Companies</Button>
                                                </Tooltip>
                                                : <Button className='modalButton' onClick={showModal} >Assign Companies</Button>}

                                        </div>
                                        <Divider />
                                        <div className='styleTab' >
                                            <Tabs type='card' tabBarGutter={2} defaultActiveKey="1" centered onChange={(key) => handleTab(key)}>
                                                <TabPane tab="Companies" key="1">
                                                    <div className='tabs' >
                                                        <Tables type="company" scroll={340} perPage={12}
                                                            source={(formState === "add") ? getDemoDefaultCompany?.payload?.data : (formState === "edit" || formState === "view" ? companyAccess?.payload?.data : [])} loading={(formState === "add") ? getDemoDefaultCompany.loading : companyAccess.loading} col={companyCol} />
                                                    </div>
                                                </TabPane>
                                                <TabPane tab="Log Info" key="logs"  >
                                                    <div className='tabs' >
                                                        <Tables type="company" scroll={360} perPage={15} source={log?.payload?.data} col={logColumns} load={log.loading} paginate />
                                                    </div>
                                                </TabPane>
                                            </Tabs>
                                        </div>
                                        <div className='modalForm' >
                                            <Modal
                                                title="Assign Companies"
                                                visible={visible}
                                                onOk={handleOk}
                                                onCancel={handleCancel}
                                                footer={null}
                                            >
                                                <Tables type="companyAccess" scroll={334} perPage={12} source={companyAll?.payload?.data} col={companyAccessCol} load={companyAll.loading} />
                                            </Modal>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                }

            </div>
            {
                minimize &&
                <div className='styleFooter' >
                    <Button className='minimize-button-style' onClick={() => setMinimize(false)}  >Style</Button>
                </div>
            }
        </div >
    )
}